(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ae-bath-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ae-bath-gallery')) customElements.define('ae-bath-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const image = this.querySelector('.ae-bath-gallery__image');
    const thumbs = [...this.querySelectorAll('[data-ae-gallery-thumb]')];
    const dialog = this.querySelector('dialog');
    const full = this.querySelector('.ae-bath-gallery__full');
    let active = Math.max(0, thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    const select = index => {
      active = (index + thumbs.length) % thumbs.length;
      const selected = thumbs[active];
      if (!selected) return;
      image.srcset = selected.dataset.srcset;
      image.src = selected.dataset.src;
      image.alt = selected.dataset.alt;
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
    };
    thumbs.forEach((button, index) => button.addEventListener('click', () => select(index)));
    this.querySelector('[data-ae-gallery-open]').addEventListener('click', () => {
      full.src = thumbs[active]?.dataset.full || image.currentSrc || image.src;
      full.alt = image.alt;
      dialog.showModal();
    });
    this.querySelector('[data-ae-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    this.querySelector('.ae-bath-gallery__strip').addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      select(active + (event.key === 'ArrowRight' ? 1 : -1));
      thumbs[active].focus();
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ae-deferred-instagram"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ae-deferred-instagram')) {
  customElements.define('ae-deferred-instagram', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.activated) return;
      const activate = () => {
        if (this.activated) return;
        this.activated = true;
        this.observer?.disconnect();
        const template = this.querySelector('template');
        const content = this.querySelector('[data-ae-instagram-content]');
        if (!template || !content) return;
        const fragment = template.content.cloneNode(true);
        const scripts = Array.from(fragment.querySelectorAll('script'));
        const reveal = () => {
          if (!content.querySelector('.instafeed-new-layout-item')) return;
          this.classList.add('is-loaded');
          this.feedObserver?.disconnect();
        };
        this.feedObserver = new MutationObserver(reveal);
        this.feedObserver.observe(content, { childList: true, subtree: true });
        content.appendChild(fragment);
        scripts.forEach(original => {
          const script = document.createElement('script');
          Array.from(original.attributes).forEach(attribute => script.setAttribute(attribute.name, attribute.value));
          script.textContent = original.textContent;
          original.replaceWith(script);
        });
        template.remove();
        reveal();
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) activate();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      } else {
        activate();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.feedObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ae-maintenance-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const button=event.target.closest('[data-ae-maintenance-decline]');
  if(!button)return;
  button.closest('.ae-maintenance-offer').hidden=true;
  (button.closest('cart-drawer')?.querySelector('[name=checkout]') || document.getElementById('checkout'))?.focus();
});
  } catch(e) { console.error(e); }
})();

})();
